import React from "react";
import "../../App.css";

export default function News() {
  return <h1 className="store">LOJA BREVEMENTE</h1>;
}
